var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"white--text",attrs:{"color":_vm.statusBgColor}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.status)))])
}
var staticRenderFns = []

export { render, staticRenderFns }